<template>
  <div>
    <Button @click = 'call'>
      问卷调查
    </Button>
    <Ccascade @change = '_change' ref = 'cas' style = "width:280px;" />
  </div>
</template>

<script>
import Ccascade from './cascade.vue'
export default {
  components:{
    Ccascade
  },
  methods: {
    _change(item){
      console.log(item)
    },
    call(){
      //cbc94f0d15214358984f3383b7758ed8
      // this.$Message.error('<a>23s')
      this.$refs['cas'].setData(['河南省','郑州市'])
      return
      this.$eventBus.emit('call_questionnaire',{
        businessKey: '2w222',
        data: {
          test: 2,
          field01: '999',
          field15: ''
        }
      })
    }
  }
}
</script>

<style>

</style>